/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { UsersFindAllRole } from './usersFindAllRole';

export type UsersFindAllParams = {
  /**
   * Page number for pagination
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Search on firstName lastName email and organization
   */
  search?: string;
  /**
   * Filter by country code
   */
  countryCode?: string;
  /**
   * Filter by role
   */
  role?: UsersFindAllRole;
  /**
   * Sort criteria array with format: [{"id": "firstName", "order": "asc"}]
   */
  sortBy?: string;
};
